<template>
  <div>
    <Spinner />
  </div>
</template>

<script>
import {
  getPrinterFriendly,
  getPaymentHistory,
  getPrinterFriendlyInvoice,
  getPrinterFriendlyTHItinerary
} from "./services";
import  Spinner from "@/partials/spinner"
import { getBooking, getOTPUnmaskedPassengerData } from "@/modules/booking/services";
import { mapState, mapGetters } from "vuex";
import { getSite } from "@/lib/utilities";
export default {
  components: {
    Spinner
  },
  data() {
    return {
      errorLoadingData: false,
    };
  },
  computed: {
    ...mapState("auth", ["userData", "token"]),
    ...mapGetters("booking", [
      "getSessionID",
      "getBookingInformation",
      "getBookingNumber",
      "getBookingSurname",
      "getConsultantInformation",
      "getDepartureDate",
      "getAccount",
      "getCostInfo",
      "getFil",
      "getBookingContacts",
      "getNamesPlus",
      "getBookingPassengers"
    ])
  },
  methods: {
    showError(variant = null, _text) {
      this.$bvToast.toast(_text, {
        title: `Error Getting PDF`,
        variant: variant,
        solid: true
      })
    },
    async getPrinterFriendlyPDF() {
      // GET Printer Friendly
      // Check email
      this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
      let result = await getBooking(
        this.getBookingSurname,
        this.getBookingNumber,
        this.userData.source,
        true,
        this.token
      ); // Method in Booking Store

      if (!result) {
        // Problem cannot continue
        // display alert
        this.$store.dispatch("spinner/updateLoadingAction", false, { root: true });
        this.showError('danger', 'No match for email address. Log out and back in to update credentials.')
        return;
      }
      const printData = {};
      printData.sessionid = this.getSessionID;
      printData.bookno = this.getBookingNumber;
      printData.fileName = `TF-${printData.bookno}-${this.getSessionID}`;

      result = await getPrinterFriendly(printData);
      const file = new Blob([result.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = fileURL;
      a.setAttribute("download", printData.fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(fileURL);
      this.$store.dispatch("spinner/updateLoadingAction", false, {
        root: true,
      });
    },
    async getPrinterFriendlyInvoicePDF() {
      try {
        let pdfcheck = await getBooking(
          this.getBookingSurname,
          this.getBookingNumber,
          this.userData.source,
          true,
          this.token
        ); // Method in Booking Store
        if (!pdfcheck) {
          // Problem cannot continue
          // display alert
          this.$store.dispatch("spinner/updateLoadingAction", false, { root: true });
          this.showError('danger', 'No match for email address. Log out and back in to update credentials.')
          return;
        }
        const invData = {};
        const bookingInformation = this.getBookingInformation; // get from store
        if (bookingInformation === null) {
          // no information so bail
          return;
        }
        this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
  
        // get unMasked user data
        // applies to staff bookings only - this is temporarily
        const unMaskedData = await getOTPUnmaskedPassengerData(
          this.token,
          this.getBookingNumber, 
          this.getBookingPassengers[0] 
        )
        invData.bookingInfo = bookingInformation;
        invData.bookingInfo.bookingNumber = this.getBookingNumber;
        invData.bookingInfo.bkgcontacts = this.getBookingContacts;
        // this is temporarily until we get approved to unmask all client data
        if(unMaskedData.data) {
          invData.bookingInfo.passenger = unMaskedData.data;
        } else {
          invData.bookingInfo.passenger = this.getBookingPassengers[0];
        }
        invData.bookingInfo.names_plus = this.getNamesPlus;
        invData.dateBkgCreated = bookingInformation.vtdate_created;
        invData.consultantInfo = this.getConsultantInformation; // from store
        invData.depDate = this.getDepartureDate; // from store
        invData.site = getSite(); // from utilities
        invData.destCountry = bookingInformation.country;
        invData.accountInfo = this.getAccount; // from store
        invData.costingInfo = this.getCostInfo; // from store
        invData.paymentHistory = null;
        // label based on Booking Type
        const invoiceLabel = this.getFil === "M" ? "Receipt" : "Invoice";
        invData.fileName = `Booking-${invoiceLabel}-${this.getBookingNumber}.pdf`;
        // get Payment History
        const payload = {
          bookingName: this.getBookingSurname,
          bookingNumber: this.getBookingNumber,
          source: this.userData.source,
          system: 'UK',
          branch: bookingInformation.branch_number,
          fil: this.getFil,
        };
  
        let result = await getPaymentHistory(payload, this.token);
        if (result.data) {
          invData.paymentHistory = result.data.receipts.summary;
          // Now call PDF service
          const invoicePDF = await getPrinterFriendlyInvoice(invData);
          if (invoicePDF.data) {
            const file = new Blob([invoicePDF.data], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);
            const a = document.createElement("a");
            a.href = fileURL;
            a.setAttribute("download", invData.fileName);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(fileURL);
          }
          this.$store.dispatch("spinner/updateLoadingAction", false, {
            root: true,
          });
        }
      } catch (error) {
        this.showError(error)
      }
    },
    async getPrinterFriendlyTHItineraryPDF(thId, uniqueRef) {
      // GET Printer Friendly Touring Hub Itinerary
      // Check email
      this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });

      const printData = {
        thId: thId,
        bookno: this.getBookingNumber,
        surname: this.getBookingSurname,
        fileName: `TF-${uniqueRef}-TOUR-ITINERARY`,
        system: this.userData.source,
        origin: 'VT_DT'
      };
      let result = await getPrinterFriendlyTHItinerary(printData);
      const file = new Blob([result.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = fileURL;
      a.setAttribute("download", printData.fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(fileURL);
      this.$store.dispatch("spinner/updateLoadingAction", false, {
        root: true,
      });
    },
  }
};
</script>